// Must also be added in Twig/FeatureFlagExtension.php
export enum FeatureFlag {
  NEW_SEARCH = 'NEW_SEARCH',
}
